import React from "react";

type Props = {
  children: React.ReactNode;
  handleSubmit: () => void;
  handleCloseModal: () => void;
  modalTitle: string;
  open: boolean;
  isLoading?: boolean;
};

const SubscriptionModal = ({
  children,
  handleSubmit,
  handleCloseModal,
  modalTitle,
  open,
  isLoading = false,
}: Props) => {
  if (!open) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        backdropFilter: "blur(4px)",
        transition: "all 0.3s ease"
      }}
      className="modal fade common-modal show d-block"
      id="addNewPlan"
      tabIndex={-1}
      aria-labelledby="addNewPlanLabel"
      aria-hidden="true"
      onClick={handleCloseModal}>
      <div
        className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
        style={{ maxWidth: "600px" }}
        onClick={(e) => e.stopPropagation()}>
        <div className="modal-content" style={{
          borderRadius: "16px",
          border: "none",
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)"
        }}>
          <div className="modal-header" style={{
            borderBottom: "1px solid #e9ecef",
            padding: "20px 24px",
            backgroundColor: "#f8f9fa"
          }}>
            <h2 style={{
              margin: 0,
              fontSize: "24px",
              fontWeight: "600",
              color: "#2c3e50"
            }}>
              {modalTitle}
            </h2>
            <button
              type="button"
              className="btn-close"
              onClick={handleCloseModal}
              aria-label="Close"
              style={{
                fontSize: "14px",
                opacity: 0.7
              }}
            />
          </div>
          <div className="modal-body" style={{
            padding: "24px",
            maxHeight: "calc(100vh - 250px)",
            overflowY: "auto"
          }}>
            <div className="common-box-body">
              {children}
            </div>
          </div>
          <div className="modal-footer" style={{
            borderTop: "1px solid #e9ecef",
            padding: "16px 24px",
            backgroundColor: "#f8f9fa",
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px"
          }}>
            <button
              className="btn btn-secondary"
              type="button"
              onClick={handleCloseModal}
              disabled={isLoading}
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                fontWeight: "500",
                minWidth: "100px"
              }}>
              Cancel
            </button>
            <button
              className="btn primary-btn"
              type="button"
              onClick={handleSubmit}
              disabled={isLoading}
              style={{
                padding: "10px 24px",
                borderRadius: "8px",
                fontWeight: "500",
                minWidth: "100px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px"
              }}>
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span>Processing...</span>
                </>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionModal;
